import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hover?: boolean;
}

const Card: React.FC<CardProps> = ({ children, className = '', onClick, hover = false }) => {
  return (
    <div
      className={`
        bg-vellum dark:bg-shadow
        border border-mist dark:border-dusk
        rounded-lg shadow-sm overflow-hidden
        ${hover ? 'hover:shadow-md hover:-translate-y-px transition-all duration-200' : ''}
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
      `}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export const CardHeader: React.FC<{ children: React.ReactNode; className?: string }> = ({ 
  children, 
  className = '' 
}) => {
  return (
    <div className={`
      bg-gradient-to-r from-parchment to-vellum dark:from-shadow dark:to-dusk/30
      border-b border-mist dark:border-dusk
      p-4
      ${className}
    `}>
      {children}
    </div>
  );
};

export const CardBody: React.FC<{ children: React.ReactNode; className?: string }> = ({ 
  children, 
  className = '' 
}) => {
  return <div className={`p-4 ${className}`}>{children}</div>;
};

export const CardFooter: React.FC<{ children: React.ReactNode; className?: string }> = ({ 
  children, 
  className = '' 
}) => {
  return (
    <div className={`p-4 border-t border-mist dark:border-dusk ${className}`}>
      {children}
    </div>
  );
};

export default Card;